import { Box, FormControlLabel, Input, Radio } from '@mui/material';
import { FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { RadioButtonsGroup } from '@/components/form-elements/RadioButtonsGroup';

type RadioButtonsYesNoDescribeProps<U extends FieldValues> = {
  label: string;
  name: FieldPath<U>;
  whichName: FieldPath<U>;
  isLoading: boolean;
  disabled?: boolean;
};

export function RadioButtonsYesNoDescribe<U extends FieldValues>({
  label,
  name,
  whichName,
  isLoading,
  disabled,
}: RadioButtonsYesNoDescribeProps<U>) {
  const { register, watch } = useFormContext<U>();
  const fieldValue = watch(name);

  return (
    <RadioButtonsGroup
      label={label}
      name={name}
      isLoading={isLoading}
      setValueAs={(value: string) => value === 'true'}
      disabled={disabled}
    >
      {[
        { value: true, label: 'Ja' },
        { value: false, label: 'Nein' },
      ].map(({ value, label: itemLabel }) => (
        <FormControlLabel key={itemLabel} value={value} control={<Radio />} label={itemLabel} />
      ))}
      {fieldValue && (
        <Box sx={{ display: 'inline-flex', flexGrow: 1, alignItems: 'center' }} component="label">
          Wenn ja, welche:
          <Box sx={{ display: 'inline-flex', flexGrow: 1 }}>
            <Input sx={{ marginLeft: 1, width: '100%' }} {...register(whichName)} />
          </Box>
        </Box>
      )}
    </RadioButtonsGroup>
  );
}
